import { configureStore } from "@reduxjs/toolkit";
import jwtLoginSlice from "./login/loginSlice";
import userLoginDetailsSlice from "./login/userLoginDetails/userLoginDetailsSlice";
import logOutSlice from "./logOut/logOutSlice";
import getAuditListSlice from "./getAuditList/getAuditListSlice";

const store = configureStore({
  reducer: {
    loginDetails: jwtLoginSlice,
    userLoginDetailsRes: userLoginDetailsSlice,
    logOut: logOutSlice,
    getAuditListRes: getAuditListSlice,
  },
});

export default store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, alerts: AlertsState}
export type AppDispatch = typeof store.dispatch;
